import { motion, HTMLMotionProps } from 'framer-motion';

interface SpringButtonProps extends HTMLMotionProps<'button'> {
  className?: string;
  children: React.ReactNode;
}

const SpringButton: React.FC<SpringButtonProps> = ({ className = '', children, ...props }: SpringButtonProps) => {
  return (
    <motion.button
      type='button'
      whileHover={{
        y: -5,
      }}
      transition={{ type: 'spring', stiffness: 200, damping: 25 }}
      className={className}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default SpringButton;
